export default __webpack_public_path__ + "src/public/DeleteIcon.svg";